import React, { useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";
import {Container, Typography, Button, Badge} from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import MaterialTable from "material-table";
import CurrencyFormat from "react-currency-format";
import axios from "axios";
import { useSnackbar } from "notistack";
import { Link, useNavigate } from "react-router-dom";
import { tableIcons } from "../../../../config/design/TableIcons";
import { currencySymbol } from "../../../../config/values";
import { getDataTableLocalization } from "../../../../config/Translate";
import { defaultVariables } from "../../../../config/index";
import { TableCount, TablePage } from "../../../../config/Permissions";
import {useTranslation} from "react-i18next";

const Wallets = () => {
    const tableRef = useRef();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [columns] = useState([
        {
            field: "user",
            editable: "never",
            filtering: false,
            title: t("fullName"),
        },
        {
            field: "mobile",
            editable: "never",
            filtering: false,
            title: t("mobile"),
        },
        {
            title: t("balance"),
            field: "amount",
            render: (rowData) => (
                <CurrencyFormat
                    value={rowData.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    suffix={" " + currencySymbol}
                />
            ),
        },
        {
            title: t("activity"),
            editable: "never",
            field: "activity",
            sorting: false,
            render: (rowData) => (
                <Badge color="primary" variant="dot" badgeContent={rowData.has_pending}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        component={Link}
                        to={`/manage/wallets/transactions/${rowData.id}`}
                        endIcon={
                            theme.direction === "rtl" ? (
                                <ChevronLeftRoundedIcon />
                            ) : (
                                <ChevronRightRoundedIcon />
                            )
                        }
                        size="small"
                        style={{ margin: 5 }}
                    >
                        {t("view")}
                    </Button>
                </Badge>

            ),
        },
    ]);

    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };

    const handleRowClick = (data) => {
        navigate(`/manage/wallet/${data.id}`);
    };

    return (
        <div className="main-table">
            <MaterialTable
                parentChildData={(row, rows) => rows.find((a) => a.id === row.parentId)}
                tableRef={tableRef}
                icons={tableIcons}
                title={" "}
                localization={getDataTableLocalization()}
                columns={columns}
                data={(query) =>
                    new Promise((resolve, reject) => {
                        const loginToken = localStorage.getItem("ACT");
                        const config = {
                            headers: {
                                Accept: "application/json",
                                Authorization: `Bearer ${loginToken}`,
                            },
                        };
                        axios
                            .get(
                                `${defaultVariables.url}/wallets/quickView?page=${
                                    query.page + 1
                                }&per_page=${query.pageSize}&search=${query.search}`,
                                config
                            )
                            .then((response) => {
                                const data = response.data.data.map((row) => ({
                                    amount: row.amount,
                                    id: row.id,
                                    user: `${row.user.first_name} ${row.user.last_name}`,
                                    mobile: row.user.mobile,
                                    active: row.active,
                                    has_pending: row.has_pending,
                                    created_at: row.created_at,
                                }));

                                resolve({
                                    data,
                                    page: response.data.current_page - 1,
                                    totalCount: response.data.total,
                                });
                            })
                            .catch((error) => {
                                console.error(error.response);

                                enqueueSnackbar(t("fetchError"), { variant: "error" });
                            });
                    })
                }
                options={{
                    pageSize: TablePage,
                    pageSizeOptions: TableCount,
                    defaultExpanded: true,
                    search: true,
                }}
            />
        </div>
    );
};

export default Wallets;
